import { RawButton, Translation } from '@ps/web-shared-components';
import React from 'react';

import type { GameTicketMPNotification } from '@swf/core/types/Notification';

import type { CardViewProps } from '../../config/NotificationTypes';
import DefaultStyles from '../../styles/shared.scss';
import Attributes from '../Attributes/Attributes';
import Buttons from '../Buttons/Buttons';
import CardDescription from '../CardDescription/CardDescription';
import Header from '../Header/Header';
import Title from '../Title/Title';

export interface CardDataProps {
  cardData: GameTicketMPNotification;
}

const GameTicket: React.FC<CardViewProps & CardDataProps> = ({
  cardData: { title, type, description, moreInfo, attributes, notificationId, headerImageURL },
  viewConfig: {
    title: titleKey,
    description: descriptionKey,
    moreInfoLabel: moreInfoKey,
    displayAttributes,
    actions,
    defaultHeaderImageURL,
    showCloseIcon
  },
  onToggleFlip,
  onClickPrimaryAction,
  onClickSecondaryAction,
  onClickClose,
  locale
}) => (
  <>
    <Header
      showCloseIcon={showCloseIcon}
      headerImageURL={headerImageURL}
      defaultHeaderImageURL={defaultHeaderImageURL}
      onClickClose={onClickClose}
    />
    <section className={DefaultStyles.notificationBody}>
      <Title title={title} titleKey={titleKey} attributes={attributes} />
      <CardDescription
        descriptionKey={descriptionKey}
        descriptionText={description}
        attributes={attributes}
      />
      {moreInfo && moreInfoKey && (
        <RawButton className={DefaultStyles.link} variant="text" onClick={onToggleFlip}>
          <Translation {...moreInfoKey.tag} values={moreInfoKey.values} />
        </RawButton>
      )}
      <Attributes displayAttributes={displayAttributes} attributes={attributes} locale={locale} />
      <Buttons
        actionList={actions}
        notificationType={type}
        attributes={attributes}
        notificationId={notificationId}
        onClickPrimaryAction={onClickPrimaryAction}
        onClickSecondaryAction={onClickSecondaryAction}
      />
    </section>
  </>
);

export default GameTicket;
